import { styled } from "@theme/stitches.config"

export const ContentWrapper = styled("div", {
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    "@lgDown": {
        flexDirection: "column"
    }
})

export const ContentLeft = styled("div", {
    display: "flex",
    maxWidth: 486,
    flexDirection: "column",
    flex: "1 0 50%",
    "& h3": {
        margin: 0
    }

})

export const ContentRight = styled("div", {
    display: "flex",
    flex: "0 0 50%"

})
